import React from "react";
import type { Product } from "../../hooks/products/types";
// import BannerOne from "./BannerOne";
import BannerTwo from "./BannerTwo";
import BannerThree from "./BannerThree";
import BannerHero from "./BannerHero";

type BannerProps = {
  variant?: "one" | "two" | "three" | "hero";
  title?: string;
  subtitle?: string;
  image?: string;
  link?: string;
  className?: string;
  products?: Product[];
  product?: Product;
};

const Banner: React.FC<BannerProps> = ({
  variant = "one",
  title,
  image,
  className = "",
  products = [],
  product,
}) => {
  const renderContent = () => {
    switch (variant) {
      case "hero":
        return <BannerHero products={products} product={product} />;
      case "two":
        return <BannerTwo products={products} product={product} />;
      case "three":
        return <BannerThree products={products} product={product} />;
      default:
        return (
          <BannerHero
            title={title}
            image={image}
            products={products}
            product={product}
          />
        );
    }
  };

  return <section className={`w-full ${className}`}>{renderContent()}</section>;
};

export default Banner;
